import React from 'react';
import type { VerticalDescriptor } from '@/core/vertical-engine/types';
import BuildProComponent from '../../modules/buildpro/BuildPro';
import { getAdapter } from '@/core/db-adapter';
import type { DBAdapter, BuildProItem, BuildProQuote } from '../../modules/buildpro/types';
import { v4 as uuidv4 } from 'uuid';

// Wrapper que inyecta la conexión a la DB real de ContikPro
function BuildProInjector() {
  const adapter: DBAdapter = {
    async saveQuote(quote: BuildProQuote): Promise<string> {
      const db = getAdapter();
      const id = quote.id || uuidv4();
      await db.put('quotes', {
        id,
        project_id: quote.projectId || null,
        subtotal: quote.totalExVat,
        tax_amount: quote.vat21,
        total: quote.totalIncVat,
        notes: quote.resumen,
        items: quote.items,
        status: 'draft',
        date: quote.createdAt,
        meta: {
          mode: quote.mode,
          tipoObra: quote.tipoObra,
          memoria: quote.memoria,
          superficie: quote.superficie,
          confianza: quote.confianza,
        }
      } as any);
      return id;
    },
    
    async upsertItems(items: BuildProItem[]): Promise<void> {
      const db = getAdapter();
      for (const item of items) {
        await db.put('items', {
           id: item.id,
           name: item.name,
           price: item.price,
           unit: item.unit,
           is_service: false,
           category: item.category,
        } as any);
      }
    },
    
    async getQuotes(projectId?: string): Promise<BuildProQuote[]> {
      const db = getAdapter();
      const docs = await db.query<any>('quotes');
      return docs
        .filter((d: any) => !projectId || d.project_id === projectId)
        .map((d: any) => ({
          id: d.id,
          projectId: d.project_id,
          mode: d.meta?.mode || 'reforma',
          tipoObra: d.meta?.tipoObra || '',
          resumen: d.notes || '',
          memoria: d.meta?.memoria || '',
          superficie: d.meta?.superficie || 0,
          confianza: d.meta?.confianza || 'media',
          items: d.items || [],
          totalExVat: d.subtotal || 0,
          vat21: d.tax_amount || 0,
          totalIncVat: d.total || 0,
          createdAt: d.date || new Date().toISOString(),
        }));
    }
  };

  return <BuildProComponent dbAdapter={adapter} />;
}

export const buildproVertical: VerticalDescriptor = {
  id: 'buildpro',
  name: 'BuildPro',
  version: '1.0.0',
  menu: [
    {
      key: 'buildpro:presupuestos',
      label: 'Presupuestos',
      path: '/presupuestos',
      icon: 'Calculator',
      order: 10,
    },
  ],
  routes: [
    {
      path: '/presupuestos',
      component: BuildProInjector,
      withLayout: true,
    },
  ],
};
